// 재생 중 미니바 — 시트를 닫고 다른 화면으로 가도 하단 탭 위에 남아 정지/다시 열기를 할 수 있다
import React, { useState } from 'react';
import { Box, ButtonBase, IconButton, Typography } from '@mui/material';
import { PauseRounded } from '@mui/icons-material';
import { useMetronome, useMetronomeClock, useBeat, formatClock } from './MetronomeProvider';

export const MINI_BAR_SPACE = 64; // 본문이 미니바에 가리지 않도록 확보할 높이

export default function MetronomeMiniBar() {
  const m = useMetronome();
  const elapsed = useMetronomeClock();
  const [beat, setBeat] = useState(-1);
  const [flash, setFlash] = useState(false);

  useBeat((ev) => {
    if (ev.beat === undefined) return;
    setBeat(ev.beat);
    if (ev.beat === 0 && !ev.muted && m.config.flash) {
      setFlash(true);
      setTimeout(() => setFlash(false), 90);
    }
  });

  if (!m?.enabled || !m.playing || m.sheetOpen) return null;
  const { config } = m;

  return (
    <>
      {/* 본문 끝에 미니바 높이만큼 여백 확보 */}
      <Box sx={{ height: MINI_BAR_SPACE }} />
      <Box
        sx={{
          position: 'fixed',
          left: 8,
          right: 8,
          bottom: 'calc(56px + env(safe-area-inset-bottom, 0px) + 8px)',
          zIndex: 995,
          maxWidth: 560,
          mx: 'auto',
          height: 52,
          borderRadius: '14px',
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          display: 'flex',
          alignItems: 'center',
          boxShadow: '0 6px 18px rgba(0,0,0,0.18)',
          outline: flash ? '3px solid' : 'none',
          outlineColor: 'secondary.main',
        }}
      >
        <IconButton onClick={() => m.stop('user')} aria-label="메트로놈 정지" sx={{ color: 'inherit', ml: 0.5 }}>
          <PauseRounded />
        </IconButton>
        <ButtonBase
          onClick={m.openSheet}
          aria-label="메트로놈 열기"
          sx={{ flex: 1, height: '100%', justifyContent: 'flex-start', gap: 1.5, pr: 2, borderRadius: '14px' }}
        >
          <Typography sx={{ fontWeight: 800, fontVariantNumeric: 'tabular-nums' }}>♩= {config.bpm}</Typography>
          <Typography sx={{ fontSize: '0.8125rem', opacity: 0.85 }}>{config.beats}/{config.unit}</Typography>
          <Typography sx={{ fontSize: '0.8125rem', opacity: 0.85, fontVariantNumeric: 'tabular-nums' }}>{formatClock(elapsed)}</Typography>
          <Box sx={{ flex: 1 }} />
          {config.beats <= 8 ? (
            <Box sx={{ display: 'flex', gap: '5px' }}>
              {Array.from({ length: config.beats }, (_, i) => (
                <Box
                  key={i}
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    bgcolor: beat === i ? 'secondary.main' : 'currentColor',
                    opacity: beat === i ? 1 : 0.3,
                  }}
                />
              ))}
            </Box>
          ) : (
            <Typography sx={{ fontSize: '0.8125rem', fontWeight: 700, color: 'secondary.main', fontVariantNumeric: 'tabular-nums' }}>
              {beat + 1}/{config.beats}
            </Typography>
          )}
        </ButtonBase>
      </Box>
    </>
  );
}
